

//const TipoTramite = resolve => { require.ensure(['../components/TipoTramite.vue'], ()=>{ resolve(require('../components/tipotramite.vue')); }); };
const casillaElectronica = resolve => {
  require.ensure(["./../components/casillaElectronica/index.vue"], () => {
    resolve(require("./../components/casillaElectronica/index.vue"));
  });
};
const PlataformaLayout = resolve => {
  require.ensure(["./../layouts/PlataformaLayout.vue"], () => {
    resolve(require("./../layouts/PlataformaLayout.vue"));
  });
};
const RegistroLayout = resolve => {
  require.ensure(["./../layouts/RegistroLayout.vue"], () => {
    resolve(require("./../layouts/RegistroLayout.vue"));
  });
};
const Pagina = resolve => {
  require.ensure(["./../views/Pagina.vue"], () => {
    resolve(require("./../views/Pagina.vue"));
  });
};
const TipoTramite = resolve => {
  require.ensure(["./../components/Tramites/TipoTramite.vue"], () => {
    resolve(require("./../components/Tramites/TipoTramite.vue"));
  });
};
const CartaExterna = resolve => {
  require.ensure(["./../components/Tramites/CartaExterna.vue"], () => {
    resolve(require("./../components/Tramites/CartaExterna.vue"));
  });
};
const RetornoVisa = resolve => {
  require.ensure(["./../components/Tramites/RetornoVisa.vue"], () => {
    resolve(require("./../components/Tramites/RetornoVisa.vue"));
  });
};
const TramiteVisa = resolve => {
  require.ensure(["./../components/Tramites/RetornoVisaTramite.vue"], () => {
    resolve(require("./../components/Tramites/RetornoVisaTramite.vue"));
  });
};
const CartaExterna2 = resolve => {
  require.ensure(["./../components/Tramites/CartaExterna2.vue"], () => {
    resolve(require("./../components/Tramites/CartaExterna2.vue"));
  });
};

const Tramite = resolve => {
  require.ensure(["./../components/Tramites/Tramite.vue"], () => {
    resolve(require("./../components/Tramites/Tramite.vue"));
  });
};
const TramitesVirtuales = resolve => {
  require.ensure(["./../components/Inicio/TramitesOnLine.vue"], () => {
    resolve(require("./../components/Inicio/TramitesOnLine.vue"));
  });
};
const TramitesVirtualesReg = resolve => {
  require.ensure(["./../components/Inicio/TramiteOnLineRegistro.vue"], () => {
    resolve(require("./../components/Inicio/TramiteOnLineRegistro.vue"));
  });
};
const PlataformaTramitesVirtuales = resolve => {
  require.ensure(["./../components/Inicio/TramitesVirtuales.vue"], () => {
    resolve(require("./../components/Inicio/TramitesVirtuales.vue"));
  });
};
const ConsultaTramite = resolve => {
  require.ensure(["./../components/Tramites/ConsultaTramite.vue"], () => {
    resolve(require("./../components/Tramites/ConsultaTramite.vue"));
  });
};
const EditarTramite = resolve => {
  require.ensure(["./../components/Tramites/EditarTramite.vue"], () => {
    resolve(require("./../components/Tramites/EditarTramite.vue"));
  });
};
const TramiteObservado = resolve => {
  require.ensure(["./../components/Tramites/TramiteObservado.vue"], () => {
    resolve(require("./../components/Tramites/TramiteObservado.vue"));
  });
};
const DescripcionTramite = resolve => {
  require.ensure(["./../components/Inicio/DescripcionTramite.vue"], () => {
    resolve(require("./../components/Inicio/DescripcionTramite.vue"));
  });
};
const ConsultaProcedimiento = resolve => {
  require.ensure(["./../components/Inicio/ConsultaProcedimientos.vue"], () => {
    resolve(require("./../components/Inicio/ConsultaProcedimientos.vue"));
  });
};
const Plataforma = resolve => {
  require.ensure(["./../components/Inicio/Plataforma.vue"], () => {
    resolve(require("./../components/Inicio/Plataforma.vue"));
  });
};
const Login = resolve => {
  require.ensure(["./../components/Inicio/Login.vue"], () => {
    resolve(require("./../components/Inicio/Login.vue"));
  });
};
const RegistroUsuarioOption = resolve => {
  require.ensure(["./../components/Usuario/RegistroOption.vue"], () => {
    resolve(require("./../components/Usuario/RegistroOption.vue"));
  });
};
const RegistroDireccion = resolve => {
  require.ensure(["./../components/Usuario/RegistroDireccion.vue"], () => {
    resolve(require("./../components/Usuario/RegistroDireccion.vue"));
  });
};
const RegistroUsuario = resolve => {
  require.ensure(["./../components/Usuario/Registro.vue"], () => {
    resolve(require("./../components/Usuario/Registro.vue"));
  });
};
const EditarUsuario = resolve => {
  require.ensure(["./../components/Usuario/EditarUsuario.vue"], () => {
    resolve(require("./../components/Usuario/EditarUsuario.vue"));
  });
};
const GeneraContrasenia = resolve => {
  require.ensure(["./../components/Usuario/GeneraContrasenia.vue"], () => {
    resolve(require("./../components/Usuario/GeneraContrasenia.vue"));
  });
};
const RecuperaContrasenia = resolve => {
  require.ensure(["./../components/Usuario/RecuperaContrasenia.vue"], () => {
    resolve(require("./../components/Usuario/RecuperaContrasenia.vue"));
  });
};
const BuscaCorreo = resolve => {
  require.ensure(["./../components/Usuario/BuscaCorreo.vue"], () => {
    resolve(require("./../components/Usuario/BuscaCorreo.vue"));
  });
};
const BuscaCorreoValido = resolve => {
  require.ensure(["./../components/Usuario/BuscaCorreoValido.vue"], () => {
    resolve(require("./../components/Usuario/BuscaCorreoValido.vue"));
  });
};
const BuscaCorreoInvalido = resolve => {
  require.ensure(["./../components/Usuario/BuscaCorreoInvalido.vue"], () => {
    resolve(require("./../components/Usuario/BuscaCorreoInvalido.vue"));
  });
};
const Recupera = resolve => {
  require.ensure(["./../components/Usuario/Recupera.vue"], () => {
    resolve(require("./../components/Usuario/Recupera.vue"));
  });
};
const DetalleDocumento = resolve => {
  require.ensure(["./../components/Tramites/DetalleDocumento.vue"], () => {
    resolve(require("./../components/Tramites/DetalleDocumento.vue"));
  });
};
const RegistroAcceso = resolve => {
  require.ensure(["./../components/AccesoInformacion/RegistroAcceso.vue"], () => {
    resolve(require("./../components/AccesoInformacion/RegistroAcceso.vue"));
  });
};
const LibroReclamaciones = resolve => {
  var url = "https://reclamos.servicios.gob.pe/?institution_id=12"
  window.location.href = url
  // require.ensure(["./../views/LibroReclamaciones/LibroReclamaciones.vue"], () => {
  //   resolve(require("./../views/LibroReclamaciones/LibroReclamaciones.vue"));
  // });
};
const ConsultaTramiteDocumentario = resolve => {
  require.ensure(
    ["./../views/TramiteDocumentario/ConsultaTramiteDocumentario.vue"],
    () => {
      resolve(
        require("./../views/TramiteDocumentario/ConsultaTramiteDocumentario.vue")
      );
    }
  );
};
const RegistroSAVE = resolve => {
  require.ensure(["./../components/SAVE/RegistroSave.vue"], () => {
    resolve(require("./../components/SAVE/RegistroSave.vue"));
  });
};
const LoginValidacion = resolve => {
  require.ensure(["./../components/Inicio/LoginValidacion.vue"], () => {
    resolve(require("./../components/Inicio/LoginValidacion.vue"));
  });
};
const consultaCancha = resolve => {
  require.ensure(["./../components/reservaCanchas/ConsultaCancha.vue"], () => {
      resolve(require("./../components/reservaCanchas/ConsultaCancha.vue"));
  });
};
const reservaCancelada = resolve => {
  require.ensure(["./../components/reservaCanchas/ReservaCancelada.vue"], () => {
      resolve(require("./../components/reservaCanchas/ReservaCancelada.vue"));
  });
};
const errorPago = resolve => {
  require.ensure(["./../components/Inicio/ErrorPago.vue"], () => {
      resolve(require("./../components/Inicio/ErrorPago.vue"));
  });
};
const MenuCanchaTenis = resolve => {
  require.ensure(["./../components/Inicio/menuTenis.vue"], () => {
      resolve(require("./../components/Inicio/menuTenis.vue"));
  });
};
const MenuCanchaTenisApp = resolve => {
  require.ensure(["./../components/Inicio/menuTenis.vue"], () => {
      resolve(require("./../components/Inicio/menuTenis.vue"));
  });
};
const reservaCancha = resolve => {
  require.ensure(["./../components/reservaCanchas/reservacanchas.vue"], () => {
      resolve(require("./../components/reservaCanchas/reservacanchas.vue"));
  });
};
const pagosOnline = resolve => {
  require.ensure(["./../components/Rentas/PagoOnline.vue"], () => {
      resolve(require("./../components/Rentas/PagoOnline.vue"));
  });
};
const pagoDirecto = resolve => {
  require.ensure(["./../components/Tramites/PagoDirecto.vue"], () => {
      resolve(require("./../components/Tramites/PagoDirecto.vue"));
  });
};
const RetornoVisaTramitePagoDirecto = resolve => {
  require.ensure(["./../components/Tramites/RetornoVisaTramitePagoDirecto.vue"], () => {
    resolve(require("./../components/Tramites/RetornoVisaTramitePagoDirecto.vue"));
  });
};
//D:\Oscar Armas\Proyectos\VUE\tramites\tramites\src\components\TipoTramite.vue
export const routes = [

  {
    path: "/",
    component: PlataformaLayout,
    children: [
      {
        path: "/",
        name: "plataforma",
        component: Plataforma,
        meta: { breadCrumb: [{ name: "Plataforma", link: "" }] }
      },
      {
        path: "/tipoTramite",
        name: "pagetipotramite",
        component: TipoTramite
      },
      {
        path: "/login",
        name: "pageLogin",
        component: Login
      },
      {
        path: "/AlquilerTenis",
        name: "MenuCanchaTenis",
        component: MenuCanchaTenis,
        meta: {
            breadCrumb: [
                { name: "Plataforma", link: "/" },
                { name: "Alquiler de cancha de tenis", link: "/AlquilerTenis/" },
                { name: null, link: "/" }
            ]
        }
    },

    {
        path: "/pagosOnline/:idArea/:idTipoTramite/:idTramite/:idPaso",
        name: "pagosOnline",
        component: pagosOnline,
        meta: {
            breadCrumb: [
                { name: "Plataforma", link: "/" },
                { name: "Alquiler de cancha de tenis", link: "/AlquilerTenis" },
                { name: "Reserva de cancha", link: "/reserva-canchas" },
                { name: "Pago Online", link: "" },
                { name: null, link: "/" }
            ]
        }
    },
    {
        path: "/reserva-canchas",
        name: "ReservaCancha",
        component: reservaCancha,
        meta: {
            breadCrumb: [
                { name: "Plataforma", link: "/" },
                { name: "Alquiler de cancha de tenis", link: "/AlquilerTenis" },
                { name: "Reserva de cancha", link: "/reserva-canchas" },
                { name: null, link: "/" }
            ]
        }
       
    },
    {
        path: "/consulta-cancha",
        name: "ConsultaCancha",
        component: consultaCancha,
        meta: {
            breadCrumb: [
                { name: "Plataforma", link: "/" },
                { name: "Alquiler de cancha de tenis", link: "/AlquilerTenis" },
                { name: "Consulta cancha", link: "/consulta-cancha" },
                { name: null, link: "/" }
            ]
        }
    },
    {
      path: "/reserva-cancelada",
      name: "ReservaCancelada",
      component: reservaCancelada
    },
    {
      path: "/error-pago",
      name: "ErrorPago",
      component: errorPago
    },
      {
        path: "/tramiteVirtual",
        name: "pagetramitevirtual",
        component: TramitesVirtuales,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/plataformatramiteVirtual" },
            { name: "Registro trámite", link: "/tramiteVirtual?ask=1" },
            { name: null, link: "/" }
          ]
        }
      },
      {
        path: "/tramiteVirtualReg/:ask&:busq",
        name: "pagetramitevirtualReg",
        component: TramitesVirtualesReg,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/tramiteVirtual" },
            { name: "Registro trámite", link: "/tramiteVirtual?ask=1" },
            { name: "Unidad Orgánica", link: "" }
          ]
        }
      },
      {
        path: "/plataformatramiteVirtual",
        name: "pagetramitevirtual",
        component: PlataformaTramitesVirtuales,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/plataformatramiteVirtual" },
            { name: null, link: "/" }
          ]
        }
      },
      {
        path: "/consultaTramite",
        //name: "pageconsultaTramite",
        name: "pageConsultatramitevirtual",
        component: ConsultaTramite,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/plataformatramiteVirtual" },
            { name: "Mis trámites", link: "" }
          ]
        }
      },
      {
        path: "/casilla-electronica",
        //name: "pageconsultaTramite",
        name: "pageCasillaElectronica",
        component: casillaElectronica,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/plataformatramiteVirtual" },
            { name: "Casilla Electrónica", link: "/" }
          ]
        }
      },
      {
        path: "/registroUsuarioOption",
        name: "pageregistroUsuarioOption",
        component: RegistroUsuarioOption,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" }
          ]
        }
      },
      {
        path: "/editarUsuario",
        name: "pagereeditarusuario",
        component: EditarUsuario,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" }
          ]
        }
      },
      {
        path: "/editarUsuario/:canchaTenis",
        name: "pagereeditarusuario",
        component: EditarUsuario,
        meta: {
            breadCrumb: [
                { name: "Plataforma", link: "/" }
            ]
        }
    },
      {
        path: "/registroDireccion",
        name: "pageRegistroDireccion",
        component: RegistroDireccion,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" }
          ]
        }
      },
      {
        path: "/registroUsuario/:tipo",
        name: "pageregistroUsuario",
        component: RegistroUsuario,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" }
          ]
        }
      },
      {
        path: "/contrasenia/:hash",
        name: "pageContrasenia",
        component: GeneraContrasenia
      },

      {
        path: "/recupera",
        name: "pageRecupera",
        component: Recupera
      },

      {
        path: "/recupera-contrasenia/:hash",
        name: "pageRecuperaContrasenia",
        component: RecuperaContrasenia
      },
      {
        path: "/busca-correo",
        name: "pageBuscaCorreo",
        component: BuscaCorreo
      },
      {
        path: "/busca-correo-valido",
        name: "pageBuscaCorreoValido",
        component: BuscaCorreoValido
      },
      {
        path: "/busca-correo-invalido",
        name: "pageBuscaCorreoInvalido",
        component: BuscaCorreoInvalido
      },
      {
        path: "/recupera-contrasenia/:hash/:proceso",
        name: "pageRecuperaContraseniaproceso",
        component: RecuperaContrasenia
      },
      {
        path: "/editarTramite/:idTramite",
        name: "pageeditarTramite",
        component: EditarTramite
      },
      {
        path: "/tramite/observado/:idArea&:idTipoTramite&:idTramite",
        name: "pageeditarTramiteObservado",
        component: TramiteObservado
      },
      {
        path: "/descripcion/:idTipoTramite&:idArea",
        name: "pageDescripciontramite",
        component: DescripcionTramite,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/tramiteVirtual" },
            { name: "Registro trámite", link: "/tramiteVirtual?ask=1" },
            { name: "Descripción de trámite", link: "" }
          ]
        }
      },
      {
        path: "/consulta-procedimiento",
        name: "pageConsultaProcedimiento",
        component: ConsultaProcedimiento,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Consulta Procedimiento", link: "" },
          ]
        }
      },

      {
        path: "/tramite/:idTipoTramite&:idTramite",
        name: "tramite",
        component: Tramite
      },
      {
        path: "/tramite/ce/:idArea&:idTipoTramite&:idTramite&:paso&:orden",
        name: "cartaTramite",
        component: CartaExterna,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/tramiteVirtual" },
            { name: "Registro trámite", link: "/tramiteVirtual?ask=1" },
            { name: "Solicitando trámite", link: "" }
          ]
        }
      },
      {
        path: "/respuesta-visa/:idArea&:idTipoTramite&:idTramite&:numeroPedido&:precio&:rpta",
        name: "cartaTramitevisa",
        component: RetornoVisa,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Trámites virtuales", link: "/tramiteVirtual" },
            { name: "Registro trámite", link: "/tramiteVirtual?ask=1" },
            { name: "Solicitando trámite", link: "" }
          ]
        }
      },
      {
        path: "/tramite-visa/:idArea&:idTipoTramite&:idTramite&:numeroPedido&:rpta",
        name: "cartaTramitevisa2",
        component: TramiteVisa
      },
      {
        path: "/tramite-visa-pago-directo/:idArea&:idTipoTramite&:idTramite&:numeroPedido&:rpta",
        name: "cartaTramitevisa3",
        component: RetornoVisaTramitePagoDirecto
      },
      {
        path: "/tramite2/ce/:idArea&:idTipoTramite&:idTramite&:paso",
        name: "carta",
        component: CartaExterna2
      },
      {
        path: "/detalle/:idExpedienteOracle",
        name: "detalleDocumento",
        component: DetalleDocumento,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Consulta Trámite", link: "/consultaTramite" }
          ]
        }
      },
      {
        path: "/consulta-procedimiento",
        name: "pageConsultaProcedimiento",
        component: ConsultaProcedimiento,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Consulta Procedimiento", link: "" },
          ]
        }
      },
      {
        path: "/registro-save",
        name: "registroSAVE",
        component: RegistroSAVE,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Registro Save", link: "" },
          ]
        }
      },
      {
        path: "/registro-save/:parametro",
        name: "registroSAVE",
        component: RegistroSAVE,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Registro Save", link: "" },
          ]
        }
      },
      {
        path: "/loginValidacion/:parametro",
        name: "pageValidacionLogin",
        component: LoginValidacion,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Validacion Login", link: "" },
          ]
        }
      },
      {
        path: "/pagodirecto/ce/:idArea&:idTipoTramite&:idTramite&:paso&:orden",
        name: "PagoDirecto",
        component: pagoDirecto,
      },
    ],
  },
  {
    path: "/",
    component: RegistroLayout,
    children: [
      {
        path: "/solicitudInfPublica",
        name: "pageSolicitudInfPublica",
        component: RegistroAcceso,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Registro Acceso Información", link: "" }
          ]
        }
      },
      {
        path: "/solicitudreclamaciones",
        name: "pageSolicitudReclamaciones",
        component: LibroReclamaciones,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Libro de Reclamaciones", link: "" }
          ]
        }

      },
      {
        path: "/consultaTramiteDocumentario",
        name: "consultaTramiteDocumentario",
        component: ConsultaTramiteDocumentario,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Consulta Tramite Documentario", link: "" }
          ]
        }
      },
      {
        path: '/consultaTramiteDocumentario/:parametro',
        name: 'consultaTramiteDocumentario',
        component: ConsultaTramiteDocumentario,
        meta: {
          breadCrumb: [
            { name: "Plataforma", link: "/" },
            { name: "Consulta Tramite Documentario", link: "" }
          ]
        }
      },
      {
        path : '/AlquilerTenis/:parametro', 
        name: 'MenuCanchaTenisApp', 
        component: MenuCanchaTenisApp, 
        meta:{ 
            breadCrumb: [
              { name: "Plataforma", link: "/" },
              { name: "Alquiler de cancha de tenis", link: "/AlquilerTenis/" },
              { name: null, link: "/" }
            ]
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js